import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

type PageProps = {
  readonly children: ReactNode;
  /** Narrower pages pass a smaller `max-w-*`; every page starts at the same left edge. */
  readonly className?: string;
};

export function Page({ children, className }: PageProps) {
  return (
    <div className={cn('flex w-full min-w-0 max-w-6xl flex-col gap-6 px-4 py-5 md:px-8 md:py-7', className)}>
      {children}
    </div>
  );
}
